import { appMethod as app } from '@utils/app';

import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import OfficialPage from '../OfficialPage';
import { TopNav } from '@common/top-nav/TopNav';
import './CouponListPage.less';

export default class CouponListPage extends OfficialPage {
  state = {
    topNavBarData: {
      isDefault: 0,
      title: '优惠券列表'
    },
    franchiseeId: '',
    franchiseeInfo: '',
    couponList: []
  }

  constructor(props) {
    super(props);
    document.title = '优惠券列表';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    var franchiseeId = options.franchisee,
      that = this
    this.setData({
      franchiseeId: franchiseeId
    })
    app.sendRequest({
      url: '/index.php?r=AppShop/GetAllShopCouponList',
      data: {
        sub_app_id: franchiseeId,
        parent_app_id: app.getAppId(),
        page: -1
      },
      success: function(res) {
        that.setData({
          couponList: res.data || []
        })
      }
    })
  }

  turnToCouponDetail = e => {
    let id = e.currentTarget.dataset.id
    app.turnToPage(
      '/pages/couponDetail/couponDetail?detail=' +
      id +
      '&franchisee=' +
      this.data.franchiseeId
    )
  }

  render() {
    const { couponList } = this.state
    return (
      <div className="official-page coupon-list-page">
        <TopNav title="优惠券列表" />
        <div className="goods-coupon-list page">
          <div className="franchisee-goods-coupon-container">
            {couponList.map((item, index) => {
              return (
                <div
                  className="coupon_ticket"
                  key={index}
                  data-id={item.id}
                  onClick={this.turnToCouponDetail}
                >
                  {item.type == 0 ? (
                    <div className="ticket-wrap">
                      <div className="price">
                        ¥<span>{item.value}</span>
                      </div>
                      <div className="coupon_right">
                        <div className="coupon_name">{item.title}</div>
                        <div>
                          {'消费满' + item.condition + '元减' + item.value}
                        </div>
                        <div className="coupon-time">
                          {(item.expire == '-1'
                            ? item.start_use_date + '至' + item.end_use_date
                            : item.expire == '0'
                              ? '领取当天生效,有效期1天'
                              : '领取' +
                              (item.react > 0 ? item.react + '天后' : '当天') +
                              '生效，有效期' +
                              item.expire +
                              '天') +
                          ' ' +
                          (item.exclude_holiday == 0
                            ? ''
                            : '除去法定节假日') +
                          ' ' +
                          (item.exclude_weekend == 0 ? '' : '周一至周五') +
                          ' ' +
                          item.start_use_time +
                          '-' +
                          item.end_use_time}
                        </div>
                      </div>
                    </div>
                  ) : item.type == 1 ? (
                    <div className="ticket-wrap">
                      <div className="price">
                        <span>{item.value + '折'}</span>
                      </div>
                      <div className="coupon_right">
                        <div className="coupon_name">{item.title}</div>
                        <div>{'打' + item.value + '折优惠'}</div>
                        <div className="coupon-time">
                          {(item.expire == '-1'
                            ? item.start_use_date + '至' + item.end_use_date
                            : item.expire == '0'
                              ? '领取当天生效,有效期1天'
                              : '领取' +
                              (item.react > 0 ? item.react + '天后' : '当天') +
                              '生效，有效期' +
                              item.expire +
                              '天') +
                          ' ' +
                          (item.exclude_holiday == 0
                            ? ''
                            : '除去法定节假日') +
                          ' ' +
                          (item.exclude_weekend == 0 ? '' : '周一至周五') +
                          ' ' +
                          item.start_use_time +
                          '-' +
                          item.end_use_time}
                        </div>
                      </div>
                    </div>
                  ) : (
                    item.type == 2 && (
                      <div className="ticket-wrap">
                        <div className="price">
                          ¥<Span>{item.value}</Span>
                        </div>
                        <div className="coupon_right">
                          <div className="coupon_name">{item.title}</div>
                          <div>{'可抵扣' + item.value + '元'}</div>
                          <div className="coupon-time">
                            {(item.expire == '-1'
                              ? item.start_use_date + '至' + item.end_use_date
                              : item.expire == '0'
                                ? '领取当天生效,有效期1天'
                                : '领取' +
                                (item.react > 0
                                  ? item.react + '天后'
                                  : '当天') +
                                '生效，有效期' +
                                item.expire +
                                '天') +
                            ' ' +
                            (item.exclude_holiday == 0
                              ? ''
                              : '除去法定节假日') +
                            ' ' +
                            (item.exclude_weekend == 0 ? '' : '周一至周五') +
                            ' ' +
                            item.start_use_time +
                            '-' +
                            item.end_use_time}
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/coupon-list-page/CouponListPage.jsx